[
  {
    "rating": 5,
    "text": {
      "text": "Het bestellen is eenvoudig, de verzending ging prima volgens afspraak. De portable monitoren zelf zijn zo opgezet en geven een prachtig beeld."
    },
    "authorAttribution": {
      "displayName": "Jeroen van Dijk",
      "photoUri": ""
    },
    "relativePublishTimeDescription": "2 weken geleden"
  },
  {
    "rating": 5,
    "text": {
      "text": "Uitstekende service en hele snelle levering. Het scherm werkt direct op mijn laptop zonder gedoe met extra drivers. Aanrader voor iedereen die veel onderweg werkt."
    },
    "authorAttribution": {
      "displayName": "Sanne de Boer",
      "photoUri": ""
    },
    "relativePublishTimeDescription": "3 weken geleden"
  },
  {
    "rating": 5,
    "text": {
      "text": "Super product! Heel licht in gewicht en gemakkelijk mee te nemen in mijn tas. Kwaliteit van het display is uitstekend voor werk en presentaties."
    },
    "authorAttribution": {
      "displayName": "Mark Bakker",
      "photoUri": ""
    },
    "relativePublishTimeDescription": "1 maand geleden"
  },
  {
    "rating": 5,
    "text": {
      "text": "Klantenservice reageerde heel snel toen ik een vraag had over de aansluiting op mijn MacBook. Erg tevreden over de aankoop!"
    },
    "authorAttribution": {
      "displayName": "Lisa Meijer",
      "photoUri": ""
    },
    "relativePublishTimeDescription": "1 maand geleden"
  }
]
